import React from 'react';
import Title from 'components/UI/Title';
import UserInfo from 'components/BusinessLogic/UserInfo';
import TravelAgency from 'components/BusinessLogic/TravelAgency';
import AgentPreferencesWidget from 'components/BusinessLogic/Agent/AgentPreferences';
import AuthenticationWidget from 'components/BusinessLogic/AuthenticationWidget';
import AssistantInfoWidget from 'components/BusinessLogic/AssistantInfo';
import RegularTravelersWidget from 'components/BusinessLogic/RegularTravelers';
import CreditCardProfileWidget from 'components/BusinessLogic/CreditCardProfile/Card';
import { faUser, faPlaneDeparture } from '@fortawesome/free-solid-svg-icons';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

function Profile({ isB2cPage })
{
    const enableCreditCard = false;
    return (
        <div className="tw-flex tw-flex-col tw-flex-1 tw-w-full h-full tw-overflow-y-auto tw-p-10 lg:tw-pl-[248px] max-sm:tw-p-2">

            <Title title="Profile" margin="tw-mb-3 max-sm:tw-mt-10 tw-mt-5" icon={faUser} />
            <UserInfo />

            <Title title="Travel Agency" icon={faPlaneDeparture} className="tw-mt-6" />
            <TravelAgency />

            {enableCreditCard && <CreditCardProfileWidget />}

            <RegularTravelersWidget />

            <AssistantInfoWidget />

            <AgentPreferencesWidget />

            <AuthenticationWidget />


            <Helmet title={`Profile | ${isB2cPage ? 'Luxuria Vacations' : 'UJV'}`}>
                <meta name="description" content="Profile" />
            </Helmet>

        </div>
    );
}

Profile.defaultProps = {
    isB2cPage: false,
};

Profile.propTypes = {
    isB2cPage: PropTypes.bool,
};

export default Profile;
